import { render, staticRenderFns } from "./EndOfLife.vue?vue&type=template&id=64c61b60&"
import script from "./EndOfLife.vue?vue&type=script&lang=js&"
export * from "./EndOfLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports